import React from 'react'
import styled from 'styled-components'
import { OutlinedButton, Paint, Size } from 'streamr-ui/Button'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import IconBox from './IconBox'
import Container from '~shared/Container'
import Topic from '~shared/Topic'
import Link from 'streamr-ui/Link'
import urls from '~utils/urls'

const UnstyledTechStack = (props) => (
    <Container {...props}>
        <IconBox>
            <IconBox.Body icon="techstack">
                <Topic.Title>
                    Tech stack
                </Topic.Title>
                <Topic.Paragraph>
                    Streamr is a layer zero protocol for real-time data which powers the decentralised Streamr pub/sub network.
                    Above it, blockchains are used for identity, security and payments, currently Ethereum and Gnosis.
                    On top is the application layer, including The Hub and all third party applications.
                </Topic.Paragraph>
                <OutlinedButton
                    tag={Link}
                    size={Size.Moose}
                    paint={Paint.PrimaryOutlined}
                    href={urls.docs.index}
                    blank
                >
                    Learn more
                </OutlinedButton>
            </IconBox.Body>
        </IconBox>
    </Container>
)

const TechStack = styled(UnstyledTechStack)`
    padding: 0 1rem;

    ${Topic.Title} {
        margin: 0;
        margin-bottom: 1rem;
        text-align: left;
    }

    ${Topic.Paragraph} {
        margin-bottom: 3rem;
        line-height: 1.75rem;
        font-size: 1rem;
    }

    ${IconBox} + ${IconBox} {
        margin-top: 1.5rem;
    }

    @media ${MqTablet} {
        padding: 0 2rem;
        max-width: 912px;

        ${IconBox} + ${IconBox} {
            margin-top: 3.5rem;
        }
    }

    @media ${MqDesktop} {
        max-width: 1160px;

        ${Topic.Paragraph} {
            font-size: 1.125rem;
            line-height: 1.875rem;
        }
    }
`

export default TechStack
